export enum QUERY_PARAMS_KEYS {
  ProjectID = 'project_id',
  UrlGroupID = 'url_group_id',
  AccountID = 'account_id',
}